import { render, staticRenderFns } from "./UgcSubmissionDetails.vue?vue&type=template&id=1cf50cfa"
import script from "./UgcSubmissionDetails.vue?vue&type=script&lang=js"
export * from "./UgcSubmissionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports